import { render, staticRenderFns } from "./ad-manager.vue?vue&type=template&id=58ae4065&scoped=true&"
import script from "./ad-manager.vue?vue&type=script&lang=js&"
export * from "./ad-manager.vue?vue&type=script&lang=js&"
import style0 from "./ad-manager.vue?vue&type=style&index=0&id=58ae4065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ae4065",
  null
  
)

export default component.exports